export default __webpack_public_path__ + "static/media/Ticket.f98d11db.svg";